// frontend/src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importer les fichiers de traduction (locales)
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';

i18n
    .use(initReactI18next) // Passe i18n à react-i18next.
    .init({
        resources: {
            en: {
                translation: en,
            },
            fr: {
                translation: fr,
            },
        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // React échappe déjà les valeurs
        },
        react: {
            useSuspense: false // Désactive le Suspense pour éviter des avertissements avec les chargements
        }
    });

export default i18n;